import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Sparkle, CircleNotch } from "@phosphor-icons/react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="grain flex h-screen flex-col items-center justify-center gap-4 bg-background">
      <div className="flex h-10 w-10 items-center justify-center rounded-md bg-action">
        <Sparkle size={22} weight="fill" className="text-white" />
      </div>
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <CircleNotch size={18} className="animate-spin" /> Signing you in…
      </div>
    </div>
  );
}
